__turbopack_context__.v({
  "authlayout": "AuthenticatedGridTemplate-module__GwllvW__authlayout",
});
